import React from 'react';
import { Flex, Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import FormHeader from '../../../components/FormHeader/FormHeader.tsx';
import AleaArchiveIcon from '../../../icons/AleaArchiveIcon.tsx';
import AleaRestoreIcon from '../../../icons/AleaRestoreIcon.tsx';

type CareHomeHeaderProps = {
  title: string;
  isCareHomeManager: boolean;
  isOrganisationManager: boolean;
  isArchived: boolean;
  onArchiveClick: () => void;
  onRestoreClick: () => void;
};

const CareHomeHeader: React.FC<CareHomeHeaderProps> = ({
  title,
  isCareHomeManager,
  isOrganisationManager,
  isArchived,
  onArchiveClick,
  onRestoreClick,
}) => {
  const { t } = useTranslation();

  if (isCareHomeManager) {
    return (
      <Flex
        justifyContent="space-between"
        alignItems={{ base: 'center', md: 'center' }}
        mb={{ base: '20px', md: '10px' }}
        h={{ base: 'auto', md: 75 }}
        flexDirection="row"
      >
        <Heading
          size="lg"
          fontSize={25}
          fontWeight={500}
          pl={{ base: 0, md: 0 }}
          mb={{ base: 1, md: 0 }}
        >
          {title}
        </Heading>
      </Flex>
    );
  }

  return (
    <FormHeader
      title={title}
      redirectUrl="/care-home-list"
      variant="card"
      actionButton={
        isOrganisationManager
          ? isArchived
            ? {
                icon: <AleaRestoreIcon size="24" />,
                label: t('restoreCareHome'),
                onClick: onRestoreClick,
                isRestore: true,
              }
            : {
                icon: <AleaArchiveIcon size="21" />,
                label: t('archiveCareHome'),
                onClick: onArchiveClick,
              }
          : undefined
      }
      canEdit={isOrganisationManager}
    />
  );
};

export default CareHomeHeader;

